export default __webpack_public_path__ + "static/ir-5340901c59b5ae98d0c522dca7810352.svg";